import React from "react";

function ComprehensiveHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-7 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Comprehensive Smart Contract Audits for Complete Assurance
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Ensure the highest security and efficiency of your
                    blockchain applications with Xeer Technology’s expert audit
                    services. Our rigorous audits bring reliability,
                    transparency, and trust to your DeFi ecosystem.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ComprehensiveHero;
